import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { Link } from '../../../partials/link/Link';

export interface LogoProps {
    svgLarge: string;
    svgSmall: string;
    svgLargeViewBox: string;
    svgSmallViewBox: string;
    alt: string;
    href: string;
}

const getLogoStyle = () => {
  return StyleSheet.create({
    base: {
      height: '24px',
      alignItems: 'center',
    },
    largeSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none',
      },
    },
    smallSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex',
      },
    },
    image: {
      height: '100%',
    },
  });
};

export const Logo: React.FunctionComponent<LogoProps> = props => {
  const { href, alt, svgLarge, svgSmall } = props;
  const style = getLogoStyle();

  return (
    <React.Fragment>
      <Link className={css(style.largeSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={`data:image/svg+xml,${encodeURIComponent(svgLarge)}`} />
      </Link>
      <Link className={css(style.smallSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={`data:image/svg+xml,${encodeURIComponent(svgSmall)}`} />
      </Link>
    </React.Fragment>
  );
};
